<template>
  <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
    <ts-loading-banner :loading="loading">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center">
              {{ $t('saleContract.unitPriceSold') }}
            </th>
            <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center">
              {{ $t('saleContract.uThbSold') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="soldPrice.length == 0">
            <td class="ts-text-red-500 ts-h-10 ts-text-center" colspan="2">
              No Sold Price
            </td>
          </tr>
          <tr
            v-for="(price, index) in soldPrice"
            :key="index"
            class="ts-cursor-pointer hover:ts-bg-gray-300"
            :class="{
              active: current_active == price.unit_price,
            }"
            @click="selectItem(price.unit_price)"
          >
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-right">
              {{ $currencyFormat(price.unit_price) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-right">
              {{ $currencyFormat(price.unit_price * 32, 'THB', 'th-TH') }}
            </td>
          </tr>
        </tbody>
      </table>
    </ts-loading-banner>
  </div>
  <!-- <small
      ><i>{{ $t('saleContract.clickToAddPrice') }}</i></small
    > -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'SoldPrice',
  props: ['value', 'productId'],
  data() {
    return {
      product_id: null,
      soldPrice: [],
      model: {},
      loading: false,
      current_active: null,
    }
  },
  computed: {
    ...mapState('wholesale/saleContract', ['edit_data', 'formViewData']),
  },
  created() {
    this.model = this.value
    this.product_id = this.productId
    this.fetchFormViewModel()
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['getFormViewData']),
    async fetchFormViewModel() {
      this.loading = true
      await this.getFormViewData({
        index: 'soldPrice',
        params: {
          fnName: 'soldPrice',
          product_id: this.product_id,
          customer_id: this.model.customer_id,
        },
      })
      this.soldPrice = this.formViewData['soldPrice']
      this.loading = false
    },
    selectItem(price) {
      this.current_active = price
      this.model.item_list.find((e) => e.product_id == this.product_id)[
        'unit_price'
      ] = parseFloat(price)
      this.$emit('priceChange')
    },
  },
}
</script>

<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
.active {
  background: rgba(209, 213, 219);
}
</style>